import axios from "axios";
import { Message } from "element-ui";
// import store from '@/store'
import qs from "qs";

const service = axios.create({
  baseURL: VUE_APP_URL,
  withCredentials: true,
  timeout: 30000, // request timeout
  transformRequest: [
    function(data) {
      return qs.stringify(data);
    },
  ],
});

// 请求拦截
service.interceptors.request.use(
  (config) => {
    // if (store.getters.token) {
    //     config.headers['X-Token'] = getToken()
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 0 && res.code !== 200) {
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 3 * 1000,
      });
      return Promise.reject(res);
    } else {
      return res;
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: "error",
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

// 封装post请求
export function post(url, data) {
  return service
    .request({
      url,
      data,
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      transformRequest: [
        function(data) {
          return JSON.stringify(data);
        },
      ],
    })
    .then((res) => {
      return new Promise((resolve, reject) => {
        if (res.code === 0 || res.code === 200) {
          resolve(res);
        }
        reject(res);
      });
    })
    .catch((error) => {
      // 通用异常
      return Promise.reject(error);
    });
}

// 封装get请求
export function get(url, params) {
  return service
    .request({
      url,
      params,
      method: "get",
    })
    .then((res) => {
      return new Promise((resolve, reject) => {
        if (res.code === 0 || res.code === 200) {
          resolve(res);
        }
        reject(res);
      });
    })
    .catch((error) => {
      // 通用异常
      return Promise.reject(error);
    });
}

export default service;
